export default function updateExternalSelectedInput(selected = {}) {
  const inputs = document.querySelectorAll('.react-table-output-selected');
  if (inputs.length) {
    Array.from(inputs).forEach((input) => {
      // eslint-disable-next-line no-param-reassign
      input.value = Object.keys(selected).join(',');
    });
  }
}
